module.exports = __webpack_public_path__ + "assets/img/banner.0c42ac6f.jpg";